<template>
  <div class="mp_preview">
    <div class="mp_preview_head">
      <div class="mp_preview_head_title">
        <Icon type="ios-phone-portrait" size="18" color="#0466dd" />
        <span>求职者-手机端预览</span>
      </div>
      <!-- <div class="mp_preview_head_tools">
        <a class="mp_tool_link" @click="all_show">全部显示</a>
        <span class="mp_tool_split">|</span>
        <a class="mp_tool_link" @click="all_hide">全部隐藏</a>
      </div> -->
    </div>

    <!-- 手机外壳按真实尺寸（375px）绘制，再由外层等比缩放，保证预览与真机一致 -->
    <div class="mp_phone_holder">
      <div class="mp_phone">
        <!-- 状态栏 -->
        <div class="mp_status_bar">
          <span class="mp_status_time">9:41</span>
          <div class="mp_status_right">
            <span class="mp_bar bar1"></span>
            <span class="mp_bar bar2"></span>
            <span class="mp_bar bar3"></span>
            <span class="mp_bar bar4"></span>
            <span class="mp_wifi"></span>
            <span class="mp_battery"></span>
          </div>
        </div>

        <!-- 导航栏 -->
        <div class="mp_nav_bar">
          <span class="mp_nav_back">
            <Icon type="ios-arrow-back" />
          </span>
          <span class="mp_nav_title">岗位详情</span>
          <span class="mp_nav_capsule">
            <span class="mp_capsule_dots">
              <i></i><i></i><i></i>
            </span>
            <span class="mp_capsule_line"></span>
            <span class="mp_capsule_circle"></span>
          </span>
        </div>

        <!-- 页面内容 -->
        <div class="mp_body">
          <!-- <div class="mp_current_job">
            当前岗位：{{ detail_info.recruitment_position || "--" }}
          </div> -->

          <!-- 企业信息卡片：Logo + 名称，下方紧跟公司介绍（最多3行，超出可展开） -->
          <div class="mp_company_card"
            v-if="is_show('project_external_name') || show_logo || is_show('company_profile')">
            <div class="mp_company_top" v-if="is_show('project_external_name') || show_logo">
              <div class="mp_company_img">
                <img v-if="show_logo" class="mp_company_logo" :src="project_logo" alt="" />
                <span v-else class="iconfont iconqiye2"></span>
                <!-- <Icon type="ios-business" size="24" color="#c9d6ea" /> -->
              </div>
              <div class="mp_company_info" v-if="is_show('project_external_name')">
                <div class="mp_company_name">
                  {{ project_external_name || "企业展示名称未完善" }}
                </div>
                <div class="mp_company_tag">
                  <Icon type="md-ribbon" size="12" />
                  <text>企业认证</text>
                </div>
              </div>
            </div>

            <div class="mp_company_profile" v-if="is_show('company_profile')">
              <div ref="profile_txt" class="mp_profile_txt" :class="{ mp_profile_collapsed: !profile_expanded }">
                {{ detail_info.company_profile || "--" }}
              </div>
              <div class="mp_profile_toggle" v-if="profile_overflow" @click="toggle_profile">
                <span>{{ profile_expanded ? "收起" : "展开" }}</span>
                <Icon :type="profile_expanded ? 'ios-arrow-up' : 'ios-arrow-down'" size="12" />
              </div>
            </div>
          </div>

          <!-- 企业图片（轮播） -->
          <div class="mp_card" v-if="image_media.length > 0">
            <div class="mp_card_title">
              <span class="mp_card_bar"></span>
              <span class="mp_card_title_txt">企业图片</span>
            </div>
            <mp_swiper :list="image_media" />
          </div>

          <!-- 企业视频（轮播，不自动切换，避免看到一半被切走） -->
          <div class="mp_card" v-if="video_media.length > 0">
            <div class="mp_card_title">
              <span class="mp_card_bar"></span>
              <span class="mp_card_title_txt">企业视频</span>
            </div>
            <mp_swiper :list="video_media" :autoplay="false" />
          </div>

          <!-- 明细分区 -->
          <template v-for="(section, si) in detail_sections" :key="si">
            <div class="mp_card" v-if="section_has_show(section)">
              <div class="mp_card_title">
                <span class="mp_card_bar"></span>
                <span class="mp_card_title_txt">{{ section.title }}</span>
              </div>
              <template v-for="field in section.fields" :key="field.key">
                <div class="mp_field" v-if="is_show(field.key)">
                  <div class="mp_field_title">{{ field.label }}</div>
                  <div class="mp_field_txt">{{ detail_info[field.key] || "--" }}</div>
                </div>
              </template>
            </div>
          </template>

          <!-- 备案号 -->
          <div class="mp_beian">
            <div class="mp_beian_item">工信部备案号：湘ICP备2022000332号-4X</div>
            <div class="mp_beian_item">
              <span style="margin-right: 6px">©版权所有 2021-{{ current_year }}</span>
              湘公网安备430190020016
            </div>
          </div>

          <div style="height: 70px"></div>
        </div>

        <!-- 底部操作栏 -->
        <div class="mp_bottom_bar">
          <div class="mp_share_btn">
            <Icon type="ios-redo" size="16" />
            <span>转发</span>
          </div>
          <div class="mp_apply_btn">
            <Icon type="ios-call" size="17" />
            <span>点击报名</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 小程序"岗位详情"页字段分区配置，与小程序 pages_job/project_info/project_info.vue 一一对应
const DETAIL_SECTIONS = [
  {
    title: "招聘详细信息",
    fields: [
      { key: "work_environment", label: "工作环境" },
      { key: "work_type", label: "用工性质" },
      { key: "work_special_instructions", label: "用工特殊说明" },
      { key: "recruitment_position", label: "招聘岗位" },
      { key: "work_uniform", label: "工服说明" },
      { key: "work_type_desc", label: "工种说明" },
      { key: "man_hour_desc", label: "工时说明" },
      { key: "repast_desc", label: "就餐" },
      { key: "dormitory_desc", label: "住宿" },
      { key: "promised_salary", label: "安心保承诺薪资" },
      { key: "salary_structure", label: "薪资属性/构成" },
      { key: "salary_desc", label: "薪酬" },
      { key: "other_subsidies", label: "其他和钱相关补贴" },
      { key: "pay_day", label: "发薪日/发放说明" },
      { key: "prepay_wage", label: "工资/生活费预支" },
      { key: "bank_black", label: "银行黑户" },
      { key: "bank_card", label: "银行卡要求" },
      { key: "contract_desc", label: "合同说明" },
      { key: "work_relation", label: "用工关系" },
      { key: "insurance_desc", label: "保险说明" },
    ],
  },
  {
    title: "录用条件",
    fields: [
      { key: "age_gender_desc", label: "性别/年龄要求" },
      { key: "nation_hukou_desc", label: "民族/户籍要求" },
      { key: "experience_desc", label: "证件/学历/经验要求" },
      { key: "health_examination", label: "体检说明" },
      { key: "other_requirements", label: "其他硬性要求" },
    ],
  },
  {
    title: "面试及入职流程",
    fields: [
      { key: "interview_location", label: "工作/面试地点" },
      { key: "interview_requirements", label: "面试携带/着装要求" },
      { key: "interview_time", label: "面试时间" },
      { key: "interview_flow", label: "面试/入职流程" },
      { key: "induction_materials", label: "入职材料/通知模板" },
      { key: "entry_fee", label: "入职费用" },
      { key: "dimission_desc", label: "离职说明" },
      { key: "jd", label: "职位JD" },
    ],
  },
];

import mp_swiper from "./mp_swiper.vue";

export default {
  name: "ProjectIntroductionPreview",
  components: {
    mp_swiper,
  },
  props: {
    // 项目介绍详情数据
    detail_info: {
      type: Object,
      default: () => ({}),
    },
    // 项目照片
    image_list: {
      type: Array,
      default: () => [],
    },
    // 项目视频
    video_list: {
      type: Array,
      default: () => [],
    },
    // 项目Logo地址（未上传时为空字符串）
    project_logo: {
      type: String,
      default: "",
    },
    // 项目对外名称（企业卡片展示的名称，来源为财务项目组对外名称）
    project_external_name: {
      type: String,
      default: "",
    },
    // 显示/隐藏配置，key 为字段名，值为 false 时不展示
    show_config: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      detail_sections: DETAIL_SECTIONS,
      // 公司介绍：是否展开、是否超过3行需要折叠
      profile_expanded: false,
      profile_overflow: false,
      current_year: new Date().getFullYear(),
    };
  },
  computed: {
    // Logo 已上传且开关打开时才展示，否则回退到默认企业图标
    // （显示开关的 key 与后台字段名保持一致，统一用 avatar）
    show_logo() {
      return this.is_show("avatar") && !!this.project_logo;
    },

    // 项目照片（按显示开关过滤）
    image_media() {
      if (!this.is_show("project_image")) {
        return [];
      }
      return this.image_list
        .filter(function (item) {
          return item && item.url;
        })
        .map(function (item) {
          return { url: item.url, type: "image" };
        });
    },

    // 项目视频（按显示开关过滤）
    video_media() {
      if (!this.is_show("project_video")) {
        return [];
      }
      return this.video_list
        .filter(function (item) {
          return item && item.url;
        })
        .map(function (item) {
          return { url: item.url, type: "video" };
        });
    },
  },
  watch: {
    // 公司介绍文案变化时，回到折叠态并重新判断是否需要“展开”
    "detail_info.company_profile"() {
      this.reset_profile_clamp();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.check_profile_overflow();
    });
  },
  methods: {
    // 默认展示，只有显式配置为 false 才隐藏
    is_show(key) {
      return this.show_config[key] !== false;
    },

    // 在折叠态下测量，判断公司介绍是否超过3行（超过才显示“展开”）
    check_profile_overflow() {
      var el = this.$refs.profile_txt;
      this.profile_overflow = el ? el.scrollHeight - el.clientHeight > 1 : false;
    },

    // 文案变化时先回到折叠态，再重新测量
    reset_profile_clamp() {
      this.profile_expanded = false;
      this.$nextTick(() => {
        this.check_profile_overflow();
      });
    },

    toggle_profile() {
      this.profile_expanded = !this.profile_expanded;
    },

    // 整个分区是否还有需要展示的字段
    section_has_show(section) {
      return section.fields.some((item) => this.is_show(item.key));
    },

    all_show() {
      this.$emit("change-all", true);
    },

    all_hide() {
      this.$emit("change-all", false);
    },
  },
};
</script>

<style scoped>
.iconqiye2{
  font-size: 42px;
  color:#0466dd;
}

.mp_preview {
  /* 手机外壳总尺寸（含边框），内部内容区为 375 x 720 */
  --mp_phone_w: 391px;
  --mp_phone_h: 736px;
  width: 100%;
}

.mp_preview_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px 8px 5px;
}

.mp_preview_head_title {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.mp_preview_head_title span {
  margin-left: 4px;
}

.mp_preview_head_tools {
  font-size: 12px;
  color: #999;
}

.mp_tool_link {
  color: #0466dd;
  cursor: pointer;
}

.mp_tool_link:hover {
  text-decoration: underline;
}

.mp_tool_split {
  margin: 0 6px;
  color: #ddd;
}

/* 缩放占位容器：宽高按缩放后的实际尺寸占位，避免下方留白。
   缩放比例由外部传入的 --mp_scale 控制（页面按屏幕宽度逐级调整），未传入时默认 0.7 */
.mp_phone_holder {
  width: calc(var(--mp_phone_w) * var(--mp_scale, 0.7));
  height: calc(var(--mp_phone_h) * var(--mp_scale, 0.7));
  margin: 0 auto;
}

/* 手机外壳 */
.mp_phone {
  position: relative;
  box-sizing: border-box;
  width: var(--mp_phone_w);
  height: var(--mp_phone_h);
  background-color: #f7f7fa;
  border: 8px solid #23262e;
  border-radius: 34px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transform: scale(var(--mp_scale, 0.7));
  transform-origin: top left;
}

/* 状态栏 */
.mp_status_bar {
  height: 26px;
  flex-shrink: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 20px;
  font-size: 11px;
  color: #333;
  font-weight: 600;
}

.mp_status_right {
  display: flex;
  align-items: center;
  height: 10px;
}

.mp_bar {
  width: 3px;
  background-color: #333;
  border-radius: 1px;
  margin-right: 2px;
}

.bar1 {
  height: 4px;
}

.bar2 {
  height: 6px;
}

.bar3 {
  height: 8px;
}

.bar4 {
  height: 10px;
  margin-right: 6px;
}

.mp_wifi {
  width: 11px;
  height: 8px;
  border-radius: 1px;
  background: linear-gradient(to top right, #333 45%, transparent 46%);
  margin-right: 5px;
}

.mp_battery {
  width: 18px;
  height: 9px;
  border: 1px solid #333;
  border-radius: 2px;
  position: relative;
}

.mp_battery::after {
  content: "";
  position: absolute;
  left: 1px;
  top: 1px;
  bottom: 1px;
  width: 11px;
  background-color: #333;
  border-radius: 1px;
}

/* 导航栏 */
.mp_nav_bar {
  height: 42px;
  flex-shrink: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 1px solid #f0f0f0;
}

.mp_nav_back {
  position: absolute;
  left: 14px;
  font-size: 19px;
  color: #333;
  line-height: 1;
}

.mp_nav_title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.mp_nav_capsule {
  position: absolute;
  right: 12px;
  width: 74px;
  height: 26px;
  border: 1px solid #e6e6e6;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.mp_capsule_dots {
  display: flex;
  align-items: center;
}

.mp_capsule_dots i {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: #333;
  margin-right: 2px;
}

.mp_capsule_line {
  width: 1px;
  height: 14px;
  background-color: #e6e6e6;
  margin: 0 7px;
}

.mp_capsule_circle {
  width: 11px;
  height: 11px;
  border: 1.5px solid #333;
  border-radius: 50%;
  position: relative;
}

.mp_capsule_circle::after {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #333;
}

/* 内容区 */
.mp_body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.mp_body::-webkit-scrollbar {
  width: 4px;
}

.mp_body::-webkit-scrollbar-thumb {
  background-color: #d8d8d8;
  border-radius: 2px;
}

.mp_current_job {
  padding: 12px 10px 4px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

/* 企业卡片 */
.mp_company_card {
  padding: 8px 10px;
  margin: 8px 10px 10px 10px;
  background-color: #fff;
  border-radius: 3px;
}

/* 名称行：Logo + 名称 */
.mp_company_top {
  display: flex;
  align-items: center;
}

/* 公司介绍：位于名称行下方 */
.mp_company_profile {
  margin-top: 8px;
  padding-top: 8px;
}

/* 只有名称行存在时才画分隔线 */
.mp_company_top + .mp_company_profile {
  border-top: 1px solid #f1f1f1;
}

.mp_profile_txt {
  font-size: 13px;
  color: #797979;
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 折叠态：最多显示 3 行，超出部分隐藏 */
.mp_profile_collapsed {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.mp_profile_toggle {
  margin-top: 4px;
  font-size: 12px;
  color: #0466dd;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.mp_profile_toggle span {
  margin-right: 2px;
}

.mp_company_img {
  width: 50px;
  height: 50px;
  border: 1px solid #f4f4f4;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.mp_company_logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.mp_company_info {
  margin-left: 10px;
  overflow: hidden;
}

.mp_company_name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mp_company_tag {
  display: inline-flex;
  align-items: center;
  margin-top: 5px;
  font-size: 12px;
  color: #535353;
}

.mp_company_tag text {
  margin-left: 2px;
}

/* 卡片 */
.mp_card {
  background-color: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
}

.mp_card_title {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.mp_card_bar {
  width: 3px;
  height: 14px;
  background-color: #0466dd;
  border-radius: 2px;
  margin-right: 6px;
}

.mp_card_title_txt {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

/* 字段行 */
.mp_field {
  display: flex;
  align-items: flex-start;
  padding: 4px 0 8px 0;
}

.mp_field_title {
  width: 84px;
  flex-shrink: 0;
  margin-right: 8px;
  padding: 3px 4px;
  font-size: 12px;
  line-height: 16px;
  color: #475298;
  background-color: #ececfa;
  border-radius: 2px;
  text-align: center;
  word-break: break-word;
}

.mp_field_txt {
  font-size: 13px;
  color: #797979;
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 备案 */
.mp_beian {
  padding: 6px 10px 10px 10px;
}

.mp_beian_item {
  font-size: 12px;
  color: #d0d0d0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 底部栏 */
.mp_bottom_bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 62px;
  background-color: #fff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.mp_share_btn {
  height: 44px;
  padding: 0 14px;
  margin-right: 12px;
  border-radius: 5px;
  background-color: #0cbe00;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.mp_share_btn span {
  margin-left: 4px;
}

.mp_apply_btn {
  width: 200px;
  height: 44px;
  border-radius: 5px;
  background-color: #0466dd;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mp_apply_btn span {
  margin-left: 4px;
}
</style>
